import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Catalog } from "../services/api";

interface BhajanState {
  catalog: Catalog | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: BhajanState = {
  catalog: null,
  status: "idle",
  error: null,
};

const bhajanSlice = createSlice({
  name: "bhajans",
  initialState,
  reducers: {
    // Saga trigger actions
    fetchBhajanDataRequest(state) {
      state.status = "loading";
      state.error = null;
    },
    refreshBhajanDataRequest(state, _action: PayloadAction<string>) {
      state.status = "loading";
      state.error = null;
    },
    // Saga success/failure actions
    fetchBhajanDataSuccess(state, action: PayloadAction<Catalog>) {
      state.status = "succeeded";
      state.catalog = action.payload;
    },
    refreshBhajanDataSuccess(state, action: PayloadAction<Catalog>) {
      state.status = "succeeded";
      state.catalog = action.payload;
    },
    fetchBhajanDataFailure(state, action: PayloadAction<string>) {
      state.status = "failed";
      state.error = action.payload;
    },
  },
});

export const selectCatalog = (state: { bhajans: BhajanState }) => state.bhajans.catalog;
export const selectStatus = (state: { bhajans: BhajanState }) => state.bhajans.status;
export const selectError = (state: { bhajans: BhajanState }) => state.bhajans.error;

export const {
  fetchBhajanDataRequest,
  refreshBhajanDataRequest,
  fetchBhajanDataSuccess,
  refreshBhajanDataSuccess,
  fetchBhajanDataFailure,
} = bhajanSlice.actions;
export default bhajanSlice.reducer;
